var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 32 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74479 20.958L0.53125 10.958L9.78349 0.875L11.6262 2.875L4.17889 10.958L11.5497 18.958L9.74479 20.958ZM21.9914 21L20.1487 19L27.596 10.917L20.2252 2.917L22.0301 0.958L31.2437 10.958L21.9914 21Z",
    fill: "#2B74E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.339621e9055f724757c358745e4cc1a8.svg";
export { ForwardRef as ReactComponent };